'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSendNewEmailCapturePromptMessage = undefined;

var _hasBotMessages = require('conversations-schema/thread-history/operators/hasBotMessages');

var _hasEmailCapturePromptFromCurrentSession = require('./hasEmailCapturePromptFromCurrentSession');

var _hasAgentReplyFromCurrentSession = require('./hasAgentReplyFromCurrentSession');

var _enoughTimeHasPassedForNewAutomatedChatMessage = require('./enoughTimeHasPassedForNewAutomatedChatMessage');

var canSendNewEmailCapturePromptMessage = exports.canSendNewEmailCapturePromptMessage = function canSendNewEmailCapturePromptMessage(threadHistory) {
  return !(0, _hasAgentReplyFromCurrentSession.hasAgentReplyFromCurrentSession)(threadHistory) && !(0, _hasBotMessages.hasBotMessages)(threadHistory) && (!(0, _hasEmailCapturePromptFromCurrentSession.hasEmailCapturePromptFromCurrentSession)(threadHistory) || (0, _enoughTimeHasPassedForNewAutomatedChatMessage.enoughTimeHasPassedForNewAutomatedChatMessage)(threadHistory));
};